import { Host, h } from "@stencil/core";
/**
 * @slot Content of the button
 */
export class DnnButton {
    constructor() {
        /**
         * Defines the look of the button.
         */
        this.appearance = 'primary';
        /**
         * Optional button type,
         * can be either submit, reset or button and defaults to button if not specified.
         * Warning: DNN wraps the whole page in a form, only use this if you are handling
         * form submission manually.
         */
        this.type = 'button';
        /**
        * @deprecated Use type instead.
        * Optional button type,
        * can be either submit, reset or button and defaults to button if not specified.
        * Warning: DNN wraps the whole page in a form, only use this if you are handling
        * form submission manually.
        * Warning: This will be deprecated in the next version and replaced with a new 'type' property.
        */
        this.formButtonType = 'button';
        /**
         * Optionally reverses the button style.
         */
        this.reversed = false;
        /**
         * Optionally sets the button size, small normal or large, defaults to normal
         */
        this.size = 'normal';
        /**
         * Optionally add a confirmation dialog before firing the action.
         */
        this.confirm = false;
        /**
         * The text of the yes button for confirmation.
         */
        this.confirmYesText = "Yes";
        /**
         * The text of the no button for confirmation.
         */
        this.confirmNoText = "No";
        /**
         * The text of the confirmation message;
         */
        this.confirmMessage = "Are you sure ?";
        /**
         * Disables the button
         */
        this.disabled = false;
        this.focused = false;
        this.modalVisible = false;
    }
    componentDidLoad() {
        this.modal = this.el.shadowRoot.querySelector('dnn-modal');
    }
    handleConfirm() {
        this.modal.hide();
        this.modalVisible = false;
        this.confirmed.emit();
    }
    handleCancel() {
        this.modal.hide();
        this.modalVisible = false;
        this.canceled.emit();
    }
    handleClick() {
        if (this.confirm && !this.modalVisible) {
            this.modal.show();
            this.modalVisible = true;
            return;
        }
        if (this.type === 'submit') {
            var form = this.internals.form;
            if (form) {
                var validity = form.checkValidity();
                if (validity) {
                    const submitButton = document.createElement('button');
                    submitButton.type = 'submit';
                    submitButton.style.display = 'none';
                    form.appendChild(submitButton);
                    submitButton.click();
                    form.removeChild(submitButton);
                }
                else {
                    const invalidEvent = new window.Event('invalid', { bubbles: true, cancelable: true });
                    form.dispatchEvent(invalidEvent);
                    var formControls = form.elements;
                    for (let i = 0; i < formControls.length; i++) {
                        var control = formControls[i];
                        try {
                            if ('checkValidity' in control && typeof control['checkValidity'] === 'function') {
                                control.checkValidity();
                            }
                        }
                        catch (e) {
                            console.error(e, control);
                        }
                    }
                    var elementToScrollTo = form.querySelector(':invalid');
                    if (elementToScrollTo) {
                        elementToScrollTo.scrollIntoView({ behavior: 'smooth', block: 'center' });
                        if ('focus' in elementToScrollTo && typeof elementToScrollTo['focus'] === 'function') {
                            elementToScrollTo.focus();
                        }
                    }
                }
            }
        }
        if (this.type === 'reset') {
            var form = this.internals.form;
            if (form) {
                var resetButton = document.createElement('button');
                resetButton.type = 'reset';
                resetButton.style.display = 'none';
                form.appendChild(resetButton);
                resetButton.click();
                form.removeChild(resetButton);
            }
        }
    }
    getElementClasses() {
        const classes = [];
        classes.push(this.appearance);
        if (this.reversed) {
            classes.push('reversed');
        }
        if (this.size !== 'normal' && this.size !== undefined) {
            classes.push(this.size);
        }
        if (this.disabled) {
            classes.push('disabled');
        }
        return classes.join(' ');
    }
    render() {
        return (h(Host, { key: '2d3ec410a18888582d846d0e3306d1f95e7144e5', class: this.getElementClasses(), tabIndex: this.focused ? -1 : 0, onFocus: () => this.button.focus(), onBlur: () => this.button.blur() }, h("button", { key: '252d3528e68c0833a9d45e336563e70c13bf4267', ref: el => this.button = el, class: "button", onClick: () => this.handleClick(), disabled: this.disabled, onFocus: () => this.focused = true, onBlur: () => this.focused = false }, h("slot", { key: '9cfbe7a1cc15da1c8471e0641a82b1243114ad3f' })), this.confirm &&
            h("dnn-modal", { key: 'bd788c30986dfa0766d0ca21dbba502813f6548e', hideCloseButton: true, preventBackdropDismiss: true }, h("p", { key: '4ad7e6d564df45737e47c9e6e6e21fd763ec6128' }, this.confirmMessage), h("div", { key: '8243f08813c6e574fda8949382ee3f04932e1302', style: {
                    display: 'flex',
                    justifyContent: 'flex-end'
                } }, h("dnn-button", { key: 'cb0ec269ad877c15cebbc1d2248a1e76b37e89d9', appearance: 'primary', reversed: true, style: { margin: '5px' }, onClick: () => this.handleCancel() }, this.confirmNoText), h("dnn-button", { key: 'b5fa961a7f8b85d68132b440a12937d611d86eba', appearance: 'primary', style: { margin: '5px' }, onClick: () => this.handleConfirm() }, this.confirmYesText)))));
    }
    static get is() { return "dnn-button"; }
    static get encapsulation() { return "shadow"; }
    static get formAssociated() { return true; }
    static get originalStyleUrls() {
        return {
            "$": ["dnn-button.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["dnn-button.css"]
        };
    }
    static get properties() {
        return {
            "appearance": {
                "type": "string",
                "attribute": "appearance",
                "mutable": false,
                "complexType": {
                    "original": "'primary' | 'danger' | 'secondary' | 'tertiary'",
                    "resolved": "\"danger\" | \"primary\" | \"secondary\" | \"tertiary\"",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Defines the look of the button."
                },
                "getter": false,
                "setter": false,
                "reflect": false,
                "defaultValue": "'primary'"
            },
            "type": {
                "type": "string",
                "attribute": "type",
                "mutable": false,
                "complexType": {
                    "original": "'submit' | 'reset' | 'button'",
                    "resolved": "\"button\" | \"reset\" | \"submit\"",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Optional button type,\ncan be either submit, reset or button and defaults to button if not specified.\nWarning: DNN wraps the whole page in a form, only use this if you are handling\nform submission manually."
                },
                "getter": false,
                "setter": false,
                "reflect": false,
                "defaultValue": "'button'"
            },
            "formButtonType": {
                "type": "string",
                "attribute": "form-button-type",
                "mutable": false,
                "complexType": {
                    "original": "'submit' | 'reset' | 'button'",
                    "resolved": "\"button\" | \"reset\" | \"submit\"",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [{
                            "name": "deprecated",
                            "text": "Use type instead.\nOptional button type,\ncan be either submit, reset or button and defaults to button if not specified.\nWarning: DNN wraps the whole page in a form, only use this if you are handling\nform submission manually.\nWarning: This will be deprecated in the next version and replaced with a new 'type' property."
                        }],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "reflect": false,
                "defaultValue": "'button'"
            },
            "reversed": {
                "type": "boolean",
                "attribute": "reversed",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Optionally reverses the button style."
                },
                "getter": false,
                "setter": false,
                "reflect": false,
                "defaultValue": "false"
            },
            "size": {
                "type": "string",
                "attribute": "size",
                "mutable": false,
                "complexType": {
                    "original": "'small' | 'normal' | 'large'",
                    "resolved": "\"large\" | \"normal\" | \"small\" | undefined",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": "Optionally sets the button size, small normal or large, defaults to normal"
                },
                "getter": false,
                "setter": false,
                "reflect": false,
                "defaultValue": "'normal'"
            },
            "confirm": {
                "type": "boolean",
                "attribute": "confirm",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean | undefined",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": "Optionally add a confirmation dialog before firing the action."
                },
                "getter": false,
                "setter": false,
                "reflect": false,
                "defaultValue": "false"
            },
            "confirmYesText": {
                "type": "string",
                "attribute": "confirm-yes-text",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string | undefined",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": "The text of the yes button for confirmation."
                },
                "getter": false,
                "setter": false,
                "reflect": false,
                "defaultValue": "\"Yes\""
            },
            "confirmNoText": {
                "type": "string",
                "attribute": "confirm-no-text",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string | undefined",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": "The text of the no button for confirmation."
                },
                "getter": false,
                "setter": false,
                "reflect": false,
                "defaultValue": "\"No\""
            },
            "confirmMessage": {
                "type": "string",
                "attribute": "confirm-message",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string | undefined",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": "The text of the confirmation message;"
                },
                "getter": false,
                "setter": false,
                "reflect": false,
                "defaultValue": "\"Are you sure ?\""
            },
            "disabled": {
                "type": "boolean",
                "attribute": "disabled",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Disables the button"
                },
                "getter": false,
                "setter": false,
                "reflect": false,
                "defaultValue": "false"
            }
        };
    }
    static get states() {
        return {
            "focused": {},
            "modalVisible": {}
        };
    }
    static get events() {
        return [{
                "method": "confirmed",
                "name": "confirmed",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "Fires when confirm is true and the user confirms the action."
                },
                "complexType": {
                    "original": "any",
                    "resolved": "any",
                    "references": {}
                }
            }, {
                "method": "canceled",
                "name": "canceled",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "Fires when confirm is true and the user cancels the action."
                },
                "complexType": {
                    "original": "any",
                    "resolved": "any",
                    "references": {}
                }
            }];
    }
    static get elementRef() { return "el"; }
    static get attachInternalsMemberName() { return "internals"; }
}
//# sourceMappingURL=dnn-button.js.map
